import {Box, Grid} from '@primer/react-brand'

import {ContentfulSectionIntro} from '@github-ui/swp-core/components/contentful/ContentfulSectionIntro'

import type {GenericContent, GenericGroup, GenericSectionWithIds} from '../../../../brand/lib/types/contentful'

import {FeaturesRiver} from '../_sections/FeaturesSection/FeaturesRiver'
import {FeaturesRiverBreakout} from './FeaturesRiverBreakout'

type Props = {
  contentfulContent: GenericSectionWithIds
}

export function FeaturesSection(props: Props) {
  const {contentfulContent} = props
  const {sectionIntro} = contentfulContent.fields
  const {featuresCopilotAiCodeEditorFeaturesRiverBreakout, featuresCopilotAiCodeEditorFeaturesRivers} =
    contentfulContent.ids as {
      featuresCopilotAiCodeEditorFeaturesRiverBreakout: GenericContent
      featuresCopilotAiCodeEditorFeaturesRivers: GenericGroup
    }

  return (
    <Grid as="section">
      <Grid.Column span={12}>
        {sectionIntro ? (
          <ContentfulSectionIntro component={sectionIntro} fullWidth headingSize="3" className="mb-6" />
        ) : null}

        {featuresCopilotAiCodeEditorFeaturesRiverBreakout ? (
          <FeaturesRiverBreakout riverBreakout={featuresCopilotAiCodeEditorFeaturesRiverBreakout} />
        ) : null}

        <Box paddingBlockStart="condensed" aria-hidden />

        {featuresCopilotAiCodeEditorFeaturesRivers && featuresCopilotAiCodeEditorFeaturesRivers.fields.content ? (
          <>
            {(featuresCopilotAiCodeEditorFeaturesRivers.fields.content as GenericContent[]).map(riverItem => (
              <FeaturesRiver key={riverItem.sys.id} river={riverItem} />
            ))}
          </>
        ) : null}
      </Grid.Column>
    </Grid>
  )
}

try{ FeaturesSection.displayName ||= 'FeaturesSection' } catch {}